query coursesFilter($scenarioId: ID!, $filterId: ID, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    courses(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        name
        sectionsCount
        demand {
          id
          vacancies
          crosslist
        }
        crosslistDemands {
          id
          vacancies
          crosslist
        }
        curriculum {
          id
          name
          program {
            id
            code
            campus {
              id
              code
              name
              __typename
            }
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
        __typename
      }
      __typename
    }
    __typename
  }
}
